export default "<span [ngClass]=\"iconStatus(label)\"></span>\n{{description}}\n";